import { lazy } from '../../shared/deployment';

export const JmeBackButton = lazy(() => import('./JmeBackButton'));
export const DownloadIcsFileButton = lazy(() => import('./DownloadIcsFileButton'));
export const JmePlusMinusButtonActive = lazy(() => import('./JmePlusMinusButtonActive'));
export const JmeBreadcrumbs = lazy(() => import('./JmeBreadcrumbs'));
export const ButtonDownload = lazy(() => import('./ButtonDownload'));
export { default as JmeButton } from './JmeButton';
